import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  announcementCard: {
    height: "100%",
    background: "#FFFFFF",
    borderRadius: 8,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    minHeight: 704,
    maxHeight: 704,
    "@media (max-width: 1200px)": {
      minHeight: 674,
      maxHeight: 674
    },
    "@media (max-width: 600px)": {
      minHeight: 600,
      maxHeight: 600
    },
    "&:hover": {
      "& $announcementCardMedia": {
        "&.MediaTypeImage, &.MediaTypeGif": {
          "& > div": {
            transform: "scale(1.2)"
          }
        },
        "&:after": {
          transform: "translate(-50%, 21px)"
        }
      }
    }
  },
  announcementCardMedia: {
    position: "relative",
    overflow: "hidden",
    fontSize: 0,
    "& iframe, video": {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0
    },
    "& > div": {
      paddingTop: "56.25%",
      transition: "transform .5s"
    },
    "&.MediaTypeVideoSelfHosted": {
      "& > div": {
        width: "100%",
        height: "100%"
      },
      "video": {
        width: "100%"
      }
    },
    "& + $announcementCardInfo": {
      paddingTop: 20
    },
    "&:after": {
      content: "''",
      position: "absolute",
      top: "auto",
      bottom: -11,
      left: "50%",
      height: 32,
      width: "calc(100% + 3px)",
      background: "#FFFFFF",
      transform: "translateX(-50%) rotate(-3deg)",
      zIndex: 4,
      transition: "transform .5s"
    },
    "@media (max-width: 1200px)": {

    }
  },
  announcementCardInfo: {
    padding: "32px 32px 32px 32px",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    "@media (max-width: 1200px)": {
      padding: "20px 24px 32px 24px"
    },
    "@media (max-width: 600px)": {
      padding: "20px 24px 24px 24px"
    },
  },
  announcementCardInfoDate: {
    fontWeight: "600 !important",
    lineHeight: "1 !important",
    color: "#2D2442",
  },
  announcementCardInfoTitle: {
    color: "#2D2442",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineClamp: 2,
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
    "@media (max-width: 600px)": {
      marginTop: 4,
      fontSize: "24px !important",
    },
  },
  announcementCardInfoDescription: {
    marginTop: 16,
    color: "#878D9A",
    overflow: "hidden",
    overflowY: "auto",
    marginRight: -4,
    flex: "1 1 0",
    "&::-webkit-scrollbar": {
      width: 4,
      borderRadius: 4
    },
    "&::-webkit-scrollbar-track": {
      background: "#F0EDFD"
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#3A28A7",
      borderRadius: 4
    },
    "& a": {
      color: "#6049EB",
      textDecoration: "underline"
    },
    "@media (max-width: 600px)": {
      marginTop: 8,
      fontSize: "14px !important",
      maxHeight: 88
    },
  },
  announcementCardInfoPrize: {
    marginTop: 24,
    paddingLeft: 36,
    position: "relative",
    color: "#3A28A7",
    fontWeight: "600 !important",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineClamp: 2,
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
    "&:before": {
      content: "''",
      display: "block",
      position: "absolute",
      top: 0,
      left: 0,
      width: 24,
      height: 24,
      marginRight: 12,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17 5C17 5.55228 16.5523 6 16 6H13.0377C13.2401 4.86314 14.2335 4 15.4286 4H16C16.5523 4 17 4.44772 17 5ZM10.9623 6C10.7599 4.86314 9.76646 4 8.57143 4H8C7.44771 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6H10.9623ZM5.17071 6C5.06015 5.68722 5 5.35064 5 5C5 3.34315 6.34315 2 8 2H8.57143C9.95359 2 11.1879 2.63318 12 3.6253C12.8121 2.63318 14.0464 2 15.4286 2H16C17.6569 2 19 3.34315 19 5C19 5.35064 18.9398 5.68722 18.8293 6H19C20.6569 6 22 7.34315 22 9V10C22 11.3062 21.1652 12.4175 20 12.8293V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V12.8293C2.83481 12.4175 2 11.3062 2 10V9C2 7.34315 3.34315 6 5 6H5.17071ZM8 8H5C4.44772 8 4 8.44772 4 9V10C4 10.5523 4.44772 11 5 11H11.0034V8H11H8ZM13.0034 8V11H19C19.5523 11 20 10.5523 20 10V9C20 8.44772 19.5523 8 19 8H16H13.0034ZM6 13V20H11.0034L11.0034 13H6ZM13.0034 13L13.0034 20H18V13H13.0034Z' fill='%233A28A7'/%3E%3C/svg%3E%0A")`,
      backgroundRepeat: "no-repeat",
    },
    "@media (max-width: 600px)": {
      fontSize: "14px !important",
    },
  },
  announcementCardInfoActions: {
    marginTop: "auto",
    paddingTop: 24
  },
  announcementCardInfoCode: {
    backgroundColor: "#F0EDFD",
    color: "#3A28A7",
    borderRadius: 58,
    display: "flex",
    alignItems: "center",
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 24,
    paddingRight: 62,
    position: "relative"
  },
  announcementCardInfoCodeTitle: {
    fontWeight: "600 !important",
    whiteSpace: "nowrap",
    "@media (max-width: 600px)": {
      fontSize: "14px !important"
    }
  },
  announcementCardInfoCodeInput: {
    border: "none",
    background: "transparent",
    letterSpacing: ".06em",
    color: "#3A28A7",
    marginLeft: 12,
    outline: "none",
    maxWidth: 145,
    fontFamily: "Montserrat",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "@media (max-width: 600px)": {
      maxWidth: 110,
      marginLeft: 8
    },
  },
  announcementCardInfoCodeCopy: {
    cursor: "pointer",
    width: 24,
    height: 24,
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9 7.2C9 5.81687 9.30308 5.10807 9.73453 4.7098C10.1863 4.29275 11.0079 4 12.55 4H16.45C17.9921 4 18.8137 4.29275 19.2655 4.7098C19.6969 5.10807 20 5.81687 20 7.2V10.8C20 12.1831 19.6969 12.8919 19.2655 13.2902C18.8707 13.6546 18.1935 13.9241 17 13.9864V13.2V12.4857C17 10.7779 16.4831 9.49568 15.2258 8.75597C14.4981 8.3278 13.595 8.13591 12.6058 8.05466C12.2361 8.01686 11.85 8 11.45 8H11H9V7.2ZM7 8.0114V7.2C7 5.58314 7.34692 4.19193 8.37797 3.2402C9.38866 2.30725 10.8421 2 12.55 2H16.45C18.1579 2 19.6113 2.30725 20.622 3.2402C21.6531 4.19193 22 5.58314 22 7.2V10.8C22 12.4169 21.6531 13.8081 20.622 14.7598C19.7217 15.5909 18.4699 15.9255 17 15.9886V16.8C17 18.4169 16.6531 19.8081 15.622 20.7598C14.6113 21.6927 13.1579 22 11.45 22H7.55C5.84213 22 4.38866 21.6927 3.37797 20.7598C2.34692 19.8081 2 18.4169 2 16.8V13.2C2 11.5831 2.34692 10.1919 3.37797 9.2402C4.27832 8.4091 5.53006 8.07454 7 8.0114ZM8 10H7.55C6.00787 10 5.18634 10.2927 4.73453 10.7098C4.30308 11.1081 4 11.8169 4 13.2V16.8C4 18.1831 4.30308 18.8919 4.73453 19.2902C5.18634 19.7073 6.00787 20 7.55 20H11.45C12.9921 20 13.8137 19.7073 14.2655 19.2902C14.6969 18.8919 15 18.1831 15 16.8V15V13.2C15 11.8169 14.6969 11.1081 14.2655 10.7098C13.9255 10.396 13.3761 10.1525 12.4679 10.0512C12.049 10.0162 11.5631 10 11 10H8Z' fill='%233A28A7'/%3E%3C/svg%3E%0A")`,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    right: 24
  },
  announcementCardInfoButton: {
    width: "100%",
    marginTop: 24,
    "@media (max-width: 600px)": {
      marginTop: 8
    }
  }
});
